import { create } from 'zustand';

import type { UpgradeRequiredContext } from '@/core/authz/parse-upgrade-required-error';

type UpgradeRequiredState = {
  open: boolean;
  context: UpgradeRequiredContext | null;
  show: (context: UpgradeRequiredContext) => void;
  dismiss: () => void;
  clearContext: () => void;
};

export const useUpgradeRequiredStore = create<UpgradeRequiredState>((set) => ({
  open: false,
  context: null,
  show: (context) => set({ open: true, context }),
  dismiss: () => set({ open: false }),
  clearContext: () => set({ context: null }),
}));

export function showUpgradeRequired(context: UpgradeRequiredContext): void {
  useUpgradeRequiredStore.getState().show(context);
}
